import { render, staticRenderFns } from "./FoodCarousel.vue?vue&type=template&id=4a7c2722&"
import script from "./FoodCarousel.vue?vue&type=script&lang=js&"
export * from "./FoodCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FoodCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports